import { TUpdateClientInfoParams } from 'types/services';
import { normalizeClientProfileFormValues } from 'services/production/utils/normalizeClientProfileFormValues';
import { m8API } from 'services/production/m8';

export const updateClientInfo = async (params: TUpdateClientInfoParams) => {
  const { clientProfileFormValues, clientId } = params;

  const userProfileUpdate = normalizeClientProfileFormValues(
    clientProfileFormValues
  ).toM8UserProfileUpdate();

  await m8API.admin.updateQuestionnaireInfo({
    idUser: clientId,
    userProfileUpdate,
  });
};
